// "http://dev..site"
// export const SERVER_URL = "http://127.0.0.1:8000"
export const SERVER_URL = "https://dev-betstamp.betstamp.site";
// export const SERVER_URL = "http://localhost/betstamp-projects/betstamp/betstamp-backend/public"
// export const SERVER_URL = "http://192.168.18.22:8000"
export const API_URL = `${SERVER_URL}/api`;
// export const API_URL ='http://jason.turbosoft-technologies.com/api'
export const imagePath = (folderName, file) =>
  `${SERVER_URL}/images/${folderName}/${file}`;

export const currency = "TZS";
export const sitename = "Car Dealer Demo";
